import { mapState, mapMutations } from 'vuex'
import api from '../service/services'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import moment from 'moment'

const {
  detect
} = require('detect-browser')
const browser = detect()

export default {
  name: 'billdetail',
  data () {
    return {
      data: [],
      isLoading: false,
      data_bill: [],
      data_images: [],
      count_images: 0,
      total_images: 0,
      zipfile: [],
      error_massage: '',
      perload: 0,
      selected: false,
      checkbox_data: [],
      isDownload: 0,
      current_page: 1,
      items_perpage: 20,
      result_count: 0,
      getData: false,
      paginateData: [],
      files: [],
      guide_name: [],
      photograph_name: []
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState(['user', 'url', 'os', 'uploads']),
    ...mapMutations(['checkLogin']),
    paginate: function () {
      this.result_count = this.data_images.length
      if (this.current_page >= this.totalPages) {
        this.current_page = Math.max(0, this.totalPages)
      }
      var index = this.current_page * this.items_perpage
      return this.data_images.slice(index, index + this.items_perpage)
    },
    totalPages: function () {
      return Math.ceil(this.result_count / this.items_perpage)
    }
  },
  methods: {
    getBill (key) {
      var obj = {
        bill_key: key
      }
      api.AXbill(
        this.url,
        obj,
        result => {
          if (result.status === 1) {
            this.data = result.data
            this.data_bill = result.data.bill
            this.count_images = this.data_bill.cnt_upload
            this.total_images = this.data_bill.total_upload
            this.data_images = []
            result.data.images.forEach(val => {
              this.data_images.push({
                // src: 'https://photogenius.sgp1.digitaloceanspaces.com/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                src: '../PGws/PGDownload/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                path: '../PGws/PGDownload/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                name: val['image_name'],
                id: val['id']
              })
            })
            setTimeout(function () {
              this.perload = Math.ceil((this.count_images / this.total_images) * 100)
              if (this.count_images !== this.total_images) {
                this.getBill(key)
              } else {
                if (this.data_bill.is_expire === '0') {
                  if (this.isDownload !== 1) {
                    this.downloadFolder(key)
                  } else {
                    if (this.total_images === '') {
                      this.error_massage = 'No Data images upload'
                    } else {
                      this.error_massage = ''
                    }
                  }
                } else {
                  this.error_massage = 'Bill is expired'
                }
              }
            }.bind(this), 3000)
          } else {
            // this.isLoading = false
            this.isDownload = 1
            this.error_massage = result.data
            alert('error ' + JSON.stringify(result))
          }
        },
        error => {
          this.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    downloadFolder (key) {
      this.isLoading = true
      var obj = {
        bill_key: key
      }
      this.error_massage = 'Image processing system please wait...'
      api.AXdownloadtmp(this.url,
        obj,
        result => {
          if (result.status === 1) {
            if (result.data.bill_cnt !== null) {
              this.count_images = result.data.bill_cnt
              this.total_images = result.data.bill_upload
              if (this.count_images !== this.total_images) {
                this.downloadFolder(key)
              } else {
                console.clear()
                this.error_massage = 'Image processing system please wait...'
                this.getBill(key)
                setTimeout(function () {
                  this.isLoading = false
                  this.getData = true
                  this.setPage(1)
                }.bind(this), 1500)
                this.isDownload = 1
              }
            } else {
              this.downloadFolder(key)
            }
          } else {
            this.isLoading = false
            alert('error ' + JSON.stringify(result))
            this.error_massage = result.data
          }
        },
        error => {
          alert(JSON.stringify(error))
        })
    },
    deleteSelect () {
      this.isLoading = true
      if (this.checkbox_data.length > 0) {
        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            var obj = []
            this.checkbox_data.forEach(val => {
              obj.push({
                id: val
              })
            })
            obj = {
              bill_key: this.$route.params.key,
              image_ids: obj
            }
            api.AXdeleteimages(this.url, obj,
              result => {
                this.isLoading = false
                if (result.status === 1) {
                  swal({
                    title: 'Delete Picture Selected Success!!',
                    animation: false,
                    type: 'success',
                    customClass: 'animated tada'
                  })
                  this.getBill(this.$route.params.key)
                  console.clear()
                } else {
                  alert(JSON.stringify(result.data))
                }
                this.checkbox_data = []
                this.selected = false
              },
              error => {
                this.isLoading = false
                alert(JSON.stringify(error))
              })
          } else {
            this.selected = false
            this.isLoading = false
          }
        })
      } else {
        this.selected = false
        this.isLoading = false
      }
    },
    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById('button-to-top').style.display = 'block'
        document.getElementById('nav-bottom').style.display = 'block'
        document.getElementById('nav-top').style.display = 'none'
      } else {
        document.getElementById('button-to-top').style.display = 'none'
        document.getElementById('nav-bottom').style.display = 'none'
        document.getElementById('nav-top').style.display = 'block'
      }
    },
    topFunction () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    preview (id) {
      this.$router.push({
        name: 'ImagePreview',
        params: {
          key: this.$route.params.key,
          id: id
        }
      })
    },
    setPage (pageNumber) {
      this.getData = false
      this.current_page = pageNumber - 1
      var paginate = []
      if (pageNumber > 1) {
        paginate.push({
          text: '<<',
          number: 1
        }, {
          text: '<',
          number: pageNumber - 1
        })
      }

      if (this.totalPages > 3) {
        if (pageNumber > 1 && pageNumber !== 1) {
          paginate.push({
            active: false,
            text: 1,
            number: 1
          })
          if (pageNumber > 2) {
            paginate.push({
              active: false,
              text: '...',
              number: pageNumber - 1
            })
          }
        }

        var kk = 2
        for (var i = 0; i < 3; i++) {
          if (this.current_page < 4) {
            if (i === 0) {
              paginate.push({
                active: true,
                text: pageNumber,
                number: pageNumber
              })
            } else {
              paginate.push({
                active: false,
                text: pageNumber + i,
                number: pageNumber + i
              })
            }
          } else if (pageNumber >= this.totalPages) {
            if (i <= 1) {
              paginate.push({
                active: false,
                text: this.totalPages - (i + kk),
                number: this.totalPages - (i + kk)
              })
            } else {
              paginate.push({
                active: true,
                text: this.totalPages,
                number: this.totalPages
              })
            }
            kk = kk - 2
          } else {
            if (i === 0) {
              paginate.push({
                active: false,
                text: pageNumber - 1,
                number: pageNumber - 1
              })
            } else if (i === 1) {
              paginate.push({
                active: true,
                text: pageNumber,
                number: pageNumber
              })
            } else if (pageNumber < this.totalPages) {
              paginate.push({
                active: false,
                text: pageNumber + 1,
                number: pageNumber + 1
              })
            }
          }
        }
      } else {
        for (var s = 1; s <= this.totalPages; s++) {
          if (s === pageNumber) {
            paginate.push({
              active: true,
              text: pageNumber,
              number: pageNumber
            })
          } else {
            paginate.push({
              active: false,
              text: s,
              number: s
            })
          }
        }
      }

      if (pageNumber !== (this.totalPages - 1) && pageNumber !== this.totalPages) {
        if (paginate[6]) {
          if (paginate[6].number !== this.totalPages) {
            paginate.push({
              active: false,
              text: '...',
              number: pageNumber + 1
            })
            paginate.push({
              active: false,
              text: this.totalPages,
              number: this.totalPages
            })
          }
        } else {
          paginate.push({
            active: false,
            text: '...',
            number: pageNumber + 1
          })
          paginate.push({
            active: false,
            text: this.totalPages,
            number: this.totalPages
          })
        }
      }

      if (pageNumber < this.totalPages) {
        if (pageNumber !== this.totalPages) {
          paginate.push({
            active: false,
            text: '>',
            number: pageNumber + 1
          })
          paginate.push({
            active: false,
            text: '>>',
            number: this.totalPages
          })
        }
      }
      this.paginateData = paginate
      setTimeout(function () {
        this.getData = true
      }.bind(this), 1500)
    },
    date_format (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    previewImage () {
      this.files = []
      let uploadedFiles = this.$refs.files.files
      let folder_name = ''
      for (var i = 0; i < uploadedFiles.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(uploadedFiles[i].name)) {
          this.files.push(uploadedFiles[i])
          folder_name = uploadedFiles[i]['webkitRelativePath']
        }
      }
      var fl = folder_name.split('/')
      this.fd_name = fl[0]
      if (this.check_str(this.fd_name) === false) {
        if (uploadedFiles.length > 0) {
          this.getImagePreviews()
          $('#Upload').modal('show')
        }
      } else {
        alert('กรุณาเปลี่ยนชื่อโฟร์เดอร์  * ชื่อไม่ควรเป็นภาษาไทย *')
        this.files = []
        this.getImagePreviews()
        const input = this.$refs.files
        input.type = 'text'
        input.type = 'file'
      }
    },
    check_str (value) {
      return /^[ก-๙]+$/gi.test(value)
    },
    getImagePreviews () {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          let reader = new FileReader()
          reader.addEventListener(
            'load',
            function () {
              this.$refs['image' + i][0].src = reader.result
            }.bind(this),
            false
          )
          reader.readAsDataURL(this.files[i])
        }
      }
    },
    fm_date (str) {
      return moment(str).format('YYYY-MM-DD')
    },
    updateProgressBarValue (billId, prevent) {
      var load = Math.round((prevent.loaded * 100) / prevent.total)
      var index = this.uploads.map(function (e) {
        return e.id
      }).indexOf(billId)
      if (index < 0) {
        this.uploads.push({
          id: billId,
          status: load,
          total: prevent.total
        })
      } else {
        this.uploads[index].status = load
        this.uploads[index].total = prevent.total
        if (load === 100) {
          this.uploads.splice(index, 1)
        }
      }
    },
    upload () {
      if (this.files.length > 0) {
        $('#Upload').modal('hide')
        this.isLoading = true
        var date = this.fm_date(this.data_bill.bill_date)
        let formData = new FormData()
        formData.append('bill_id', this.data_bill.bill_id)
        formData.append('bill_key', this.data_bill.bill_key)
        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i]
          formData.append('upload[' + i + ']', file)
        }
        formData.append('item_id', parseInt(this.data_bill.item_id))
        formData.append('item_qty', 1)
        formData.append('flash_drive', parseInt(this.data_bill.flashdrive))
        var guide = []
        this.guide_name.forEach(val => {
          if (val !== '') {
            guide.push({
              name: val
            })
          }
        })
        formData.append('guide_name', this.guide_name.length)

        var phg = []
        this.photograph_name.forEach(key => {
          if (key !== '') {
            phg.push({
              name: key
            })
          }
        })
        formData.append('photograph_name', this.photograph_name.length)

        formData.append('bill_amount', parseInt(this.data_bill.bill_amount))
        formData.append('cash_amount', 0)
        formData.append('credit_amount', 0)
        formData.append('folder_date', date)
        formData.append('folder_name', this.data_bill.bill_folder)
        formData.append('user_id', this.data_bill.user_id)
        formData.append('upload_status', 1)
        formData.append('bill_status', this.data_bill.bill_status)
        formData.append('discription', this.data_bill.discription)
        formData.append('is_new', 0)

        var header = {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.updateProgressBarValue(this.data_bill.bill_number, progressEvent)
            }
          }
        }

        // for (var pair of formData.entries()) {
        //   console.log(pair[0] + ', ' + pair[1])
        // }
        var billId = this.data_bill.bill_id
        setTimeout(function () {
          this.isLoading = false
          this.$router.push({
            name: 'Home'
          })
        }.bind(this), 3000)
        api.AXupload_cloud(
          this.url,
          formData,
          header,
          result => {
            if (result.status === 1) {
              var index = this.uploads.map(function (e) {
                return e.id
              }).indexOf(billId)
              swal(
                'Good job!',
                'Upload File Completed!',
                'success'
              )
              this.uploads.splice(index, 1)
              console.clear()
            } else {
              swal(
                'Warnning!',
                result.data,
                'error'
              )
            }
          },
          error => {
            var index = this.uploads.indexOf(this.data_bill.bill_id)
            this.uploads.splice(index, 1)
            alert(JSON.stringify(error))
          }
        )
      }
    },
    uploadgoogle () {
      swal({
        title: 'Upload google drive?',
        text: "Do you want to upload all pictures to google drive?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.value) {
          this.isLoading = true
          api.AXuploadGoogle(
            'https://photoapi.extensionsoft.biz',
            {
              bill_key: this.data_bill.bill_key
            },
            result => {
              if (result.status === true) {
                swal(
                  'Good job!',
                  'Upload File Completed!',
                  'success'
                )
                this.isLoading = false
                console.clear()
              } else {
                this.isLoading = false
                swal(
                  'Warnning!',
                  result.data,
                  'error'
                )
              }
            },
            error => {
              this.isLoading = false
              alert(JSON.stringify(error))
            }
          )
        }
      })
    }
  },
  created () {
    window.addEventListener('scroll', this.scrollFunction)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollFunction)
  },
  mounted () {
    this.getBill(this.$route.params.key)
    this.$store.state.os = browser.os
    if (sessionStorage.getItem('users') === null) {
      this.$router.push({
        name: 'Detail',
        params: {
          key: this.$route.params.key
        }
      })
    } else {
      try {
        this.checkLogin()
      } catch (e) {
        // location.reload()
      }
      this.$router.push({
        name: 'BillDetail',
        params: {
          key: this.$route.params.key
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/bill_detail.js